$(".header__burger").on("click", () => {
  $(".header").toggleClass("active");
  $(".header__burger").toggleClass("active");
  $(".header-inner").toggleClass("active");
  $(".header-right").toggleClass("active");
  $("html").toggleClass("hidden");
  $("body").toggleClass("hidden");
});

$(".nav__item").on("click", () => {
  $(".header").removeClass("active");
  $(".header__burger").removeClass("active");
  $(".header-inner").removeClass("active");
  $(".header-right").removeClass("active");
  $("html").removeClass("hidden");
  $("body").removeClass("hidden");
});

$("input[type=phone]").mask("+7 (999) 999-99-99");
